import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'
import './assets/fonts/font.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App),
  //定义全局事件总线 $bus
  beforeCreate: function () {
    Vue.prototype.$bus = this;
  }
}).$mount('#app')
